import React from 'react';
import {
  CartContents,
} from '.';
import './MiniCart.scss';

const MiniCart = (props) => {
  const {
    shopSlug,
    minicartOpen,
    closeMinicart,
  } = props;
  return (
    <div className={`minicart-menu${minicartOpen ? ' is-open' : ''}`}>
      <CartContents
        shopSlug={shopSlug}
        closeMinicart={closeMinicart}
      />
    </div>
  );
};

export default MiniCart;
